const options = {
  root: null,
  rootMargin: '60px 0px -50px',
  threshold: 0
}

const options2 = {
  root: null,
  rootMargin: '0px 100%',
  threshold: 0.5
}

const completeClass = 'animate-in--complete'
const delayClass = 'animate-in--delay'

const callback = (entries, observer) => {
  entries.forEach(entry => {
    const elem = entry.target
    if (entry.isIntersecting) {
      elem.isLeaving = true
      elem.classList.add(completeClass)
      document.dispatchEvent(new CustomEvent('animate-in--complete'))
    } else if (elem.isLeaving && !elem.classList.contains('loading--once')) {
      elem.classList.remove(completeClass)
      document.dispatchEvent(new CustomEvent('animate-in--complete'))
    }
  })
}

const callback2 = (entries, observer) => {
  entries.forEach(entry => {
    const elem = entry.target
    if (entry.isIntersecting) {
      elem.isLeaving = true
      elem.classList.add(completeClass)
    }
  })
}

const observer = new IntersectionObserver(callback, options)
const observer2 = new IntersectionObserver(callback2, options2)

document.addEventListener('update-animation', function (e) {
  const animationUpdates = e.target.querySelectorAll('.animate-in')

  for (const element of animationUpdates) {
    if (!element.animationWatch) {
      observer.observe(element)
      element.animationWatch = true
    }
  }
})

const setupLoader = function (elem) {
  if (elem.classList.contains(delayClass)) {
    observer2.observe(elem)
  } else {
    observer.observe(elem)
  }
  elem.animationWatch = true
}

export {
  setupLoader
}
